'use strict';

const createSVGDOM = require('./create-svg-dom'),
	scaleDashes = require('@mindmup/mapjs-core/src/util/scale-dashes'),
	lineStrokes = require('@mindmup/mapjs-core/src/theme/line-strokes'),
	convertPositionToTransform = require('@mindmup/mapjs-core/src/util/convert-position-to-transform'),
	updateConnectorText = require('./update-connector-text'),
	calcLabelCenterPoint = require('./calc-label-center-point'),
	checkParams = require('@mindmup/js-utils/src/check-params'),
	attr = require('../dom/attr'),
	css = require('../dom/css'),
	hasArrowType = (arrowTypeRequired, arrowType) => {
		return ['both', arrowTypeRequired].includes(arrowType);
	},
	findOrCreateConnectoPaths = (domElement, connection) => {
		const pathElement = domElement.querySelector('[data-mm-role~="mapjs-connector"]'),
			afterArrowPathElement = domElement.querySelector('[data-mm-role~="mapjs-connector-after-arrow"]'),
			hitElement = domElement.querySelector('[data-mm-role~="mapjs-link-hit"]'),
			result = {pathElement, afterArrowPathElement, hitElement};

		if (!result.pathElement) {
			result.pathElement = createSVGDOM('path');
			result.pathElement.setAttribute('class', 'mapjs-connector');
			result.pathElement.setAttribute('data-mm-role', 'mapjs-connector');
			domElement.appendChild(result.pathElement);
		}
		if (!result.hitElement) {
			result.hitElement = createSVGDOM('path');
			result.hitElement.setAttribute('class', 'mapjs-link-hit noTransition');
			result.hitElement.setAttribute('data-mm-role', 'mapjs-link-hit');
			domElement.appendChild(result.hitElement);
		}
		if (connection.afterArrowD && !result.afterArrowPathElement) {
			result.afterArrowPathElement = createSVGDOM('path');
			result.afterArrowPathElement.setAttribute('class', 'mapjs-connector');
			result.afterArrowPathElement.setAttribute('data-mm-role', 'mapjs-connector-after-arrow');
			domElement.appendChild(result.afterArrowPathElement);
		} else if (!connection.afterArrowD && result.afterArrowPathElement) {
			result.afterArrowPathElement.remove();
			delete result.afterArrowPathElement;
		}
		return result;
	};


module.exports = function updateConnector(params) {
	checkParams(params, ['domElement', 'connection', 'stage', 'fromBox', 'toBox']);
	const {domElement, connection, stage, fromBox, toBox} = params,
		applyLabel = function () {
			const labelText = connection.label || '',
				labelCenterPoint = labelText && calcLabelCenterPoint(
					connection,
					fromBox,
					toBox,
					connection.d);
			updateConnectorText(
				stage,
				domElement,
				labelCenterPoint,
				labelText,
				connection.theme.label
			);
		},
		getSvgDefs = () => {
			const svgContainer = stage.getSVGContainer();
			let defs = svgContainer.querySelector('defs');
			if (!defs) {
				defs = createSVGDOM('defs');
				svgContainer.appendChild(defs);
			}
			return defs;
		},
		getArrowMarker = ({color, width, arrowExtension}) => {
			if (!arrowExtension || !width || !color) {
				throw new Error('invalid-args');
			}
			const defs = getSvgDefs(),
				arrowLength = arrowExtension.length + width, // 5
				arrowWidth = arrowExtension.width + width, // 10
				selector = String(arrowLength) + '-' + String(arrowWidth) + '-' + color.replace(/#/, '');
			let marker = defs.querySelector(`marker[for="${selector}"]`);
			if (!marker) {
				marker = createSVGDOM('marker');
				attr(marker, {
					id: 'arrow-' + selector,
					for: selector,
					viewBox: `0 0 ${arrowLength} ${arrowWidth}`,
					refX: '0',
					refY: String(arrowWidth / 2),
					markerUnits: 'userSpaceOnUse',
					markerWidth: String(arrowLength),
					markerHeight: String(arrowWidth),
					orient: 'auto-start-reverse'
				});
				defs.appendChild(marker);
				const path = createSVGDOM('path');
				attr(path, {
					d: `M 0 0 L ${arrowLength} ${arrowWidth / 2} L 0 ${arrowWidth} z`,
					fill: color
				});
				marker.appendChild(path);
			}
			return marker;
		},
		arrowType = (connection.theme.type !== 'no-connector') && connection.arrow,
		{pathElement, afterArrowPathElement, hitElement} = findOrCreateConnectoPaths(domElement, connection);
	if (!connection) {
		domElement.remove();
		return;
	}

	css(domElement, Object.assign(convertPositionToTransform(connection.position), {stroke: connection.color}));
	attr(pathElement, {
		'd': connection.d,
		'stroke-width': connection.width,
		'stroke-dasharray': scaleDashes(lineStrokes[connection.lineStyle || 'solid'], connection.width),
		'stroke-linecap': 'round',
		fill: 'transparent'
	});

	if (hasArrowType('from', arrowType)) {
		pathElement.setAttribute('marker-start', 'url(#' + getArrowMarker(connection).getAttribute('id') + ')');
	} else {
		pathElement.removeAttribute('marker-start');
	}
	if (hasArrowType('to', arrowType)) {
		pathElement.setAttribute('marker-end', 'url(#' + getArrowMarker(connection).getAttribute('id') + ')');
	} else {
		pathElement.removeAttribute('marker-end');
	}
	if (afterArrowPathElement) {
		attr(afterArrowPathElement, {
			display: '',
			'd': connection.afterArrowD,
			'stroke-width': connection.width,
			'stroke-dasharray': scaleDashes(lineStrokes[connection.lineStyle || 'solid'], connection.width),
			'stroke-linecap': 'round',
			fill: 'transparent'
		});
	}

	attr(hitElement, {
		'd': connection.d + (connection.afterArrowD || ''),
		'stroke-width': connection.width + 12
	});
	applyLabel();
};

